import { Card, CardButtonActionMode, HeaderGradient, MiniCard, Row } from '@app/components';
import React, { memo } from 'react';
import { theme } from '@app/theme';
import { useDynamicSizes } from '@app/hooks';
import LinearGradient from 'react-native-linear-gradient';
import { StyleSheet } from 'react-native';
import { IIngredient } from '@app/common';
import { useAppSelector } from '@app/store/hooks';
import { triptychSelectors } from '@app/store';
import { SlantTitle } from '@app/components/typography';
import SvgInfo from '@app/components/icons/SvgInfo';

type IngredientCardProps = {
  ingredient?: Partial<IIngredient>;
  toggle: (mode: CardButtonActionMode) => void;
};

const formatCardData = (partialIngredient: Partial<IIngredient>) => {
  return {
    name: partialIngredient?.name || 'Nouveau ingrédient',
  }
}

export const IngredientCard = memo(({ toggle, ingredient }: IngredientCardProps) => {
  const { subContainerHeight } = useDynamicSizes();

  const partialIngredient = useAppSelector<Partial<IIngredient>>(triptychSelectors.selectData);
  const cardData = useAppSelector<Partial<IIngredient>>(triptychSelectors.selectCardData);

  const { name } = formatCardData(cardData ?? partialIngredient);

  return (
    <Card>

      <HeaderGradient>
        <LinearGradient
          start={{ x: 0.5, y: 0 }}
          end={{ x: 0.5, y: 1 }}
          locations={[0, 1]}
          colors={['rgba(253, 255, 252, 0)', 'rgba(253, 255, 252, 1)']}
          style={styles.headerGradient}
        />
      </HeaderGradient>

      <Card.TopHeader>
        <Card.TopHeaderLabel>Fiche ingredient</Card.TopHeaderLabel>
      </Card.TopHeader>

      <Card.Container height={subContainerHeight}>
        <Card.Background source={require('@app/assets/img/cardbackground.png')} />

        <Card.Content>
          <Card.Header>
            {/* En-tête */}
            <Row justify="space-between" align="center">
              <Card.HeaderTitles>
                <Card.Title numberOfLines={2}>{name}</Card.Title>
                {ingredient?._id && <Card.Subtitle>Ref: {ingredient._id}</Card.Subtitle>}
              </Card.HeaderTitles>

              <Card.ButtonAction onPress={toggle} permissionScope="ingredients" />
            </Row>
          </Card.Header>
        </Card.Content>

        <MiniCard>
          <MiniCard.Tabs>
            <MiniCard.TabsHolder>
              <MiniCard.Tab Icon={SvgInfo} isActive />
            </MiniCard.TabsHolder>
          </MiniCard.Tabs>
          <MiniCard.Container>
            <MiniCard.Content>
              <SlantTitle label="Aide" color={theme.colors.gold} />

              <Card.HelpScrollContainer>

                <Card.LineBreak height={16} />

                <Card.HelpTitle>Fonctionnement des ingrédients</Card.HelpTitle>

                <Card.LineBreak height={8} />

                <Card.HelpText>Les ingrédients qui composent un produit permettent de gérer automatiquement les ruptures de stock.</Card.HelpText>

                <Card.LineBreak height={8} />

                <Card.HelpText>Par exemple, si un produit contient du saumon et que vous indiquez ne plus en avoir, le système identifie automatiquement les produits impactés et les désactive de l’ensemble de vos canaux de vente.</Card.HelpText>

                <Card.LineBreak height={356} />

              </Card.HelpScrollContainer>
            </MiniCard.Content>
          </MiniCard.Container>
        </MiniCard>

      </Card.Container>
    </Card>
  );
});


const styles = StyleSheet.create({
  headerGradient: {
    flex: 1,
    height: theme.sizes.listHeaderHeight,
  },
});
